import {HintSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {Text, useRemoveAllToasts, useShowToast} from '@aboutyou/ui-components';
import React, {useEffect} from 'react';

export const BasketHintSectionView: React.FC<HintSection> = ({type}) => {
  const showToast = useShowToast();
  const removeToast = useRemoveAllToasts();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (!type) {
      return;
    }

    showToast({
      autoHide: false,
      type: type.$case === 'warning' ? 'WARNING' : 'FAILURE',
      content:
        type.$case === 'warning' ? (
          <>
            {type.warning.headline}
            {type.warning.subline && (
              <Text size="px12">{type.warning.subline}</Text>
            )}
          </>
        ) : (
          type.error.message
        ),
    });

    return () => {
      removeToast();
    };
  }, []);

  return null;
};
